import { render, staticRenderFns } from "./Factorization.vue?vue&type=template&id=447282d2&scoped=true&lang=pug&"
import script from "./Factorization.vue?vue&type=script&lang=js&"
export * from "./Factorization.vue?vue&type=script&lang=js&"
import style0 from "./Factorization.vue?vue&type=style&index=0&id=447282d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447282d2",
  null
  
)

export default component.exports